export interface PosPaymentMethodOption {
  id: number;
  is_active?: boolean;
}

export const getQuickPaymentMethods = <T extends PosPaymentMethodOption>(
  methods: T[],
): T[] => methods.filter((method) => method.is_active !== false).slice(0, 4);
